import React from 'react';
import { motion } from 'framer-motion';
import { ChoiceCue } from '../ChoiceCue';
import { reflection } from '../../../data/snak';
import { clusters } from '../../../data/teaser';
const EASE = [0.23, 1, 0.32, 1] as const;
interface ReflectionPageProps {
  selected: string | null;
  onSelect: (id: string) => void;
  showPeerData: boolean;
}
export function ReflectionPage({
  selected,
  onSelect,
  showPeerData
}: ReflectionPageProps) {
  return <div className="flex flex-1 flex-col" data-id="element-166" data-mp="3np338eohs0hv">
      <div className="grid h-[34%] shrink-0 grid-cols-4 gap-px bg-navy/15" data-id="element-167" data-mp="3rqopurqtvt59">
        {clusters.map((c, i) => <div key={c.id} className="relative overflow-hidden bg-ink" data-id="element-168" data-mp="br3fd09540r" data-mpi={i}>
            <img src={c.image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-169" data-mp="5bcaybthmkp3" />
            <div className="scanlines pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-170" data-mp="f9jdvqqxz283" />
            <span className="absolute bottom-2.5 left-3 font-display text-[11px] font-bold tabular-nums text-paper/70" data-id="element-171" data-mp="f75nvwb4cg7e">
              {String(i + 1).padStart(2, '0')}
            </span>
          </div>)}
      </div>

      <div className="flex flex-1 flex-col justify-center px-10 py-7" data-id="element-172" data-mp="2zthsy1h6c6er">
        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="max-w-3xl font-display text-[32px] font-semibold leading-[1.06] tracking-tight text-navy" data-id="element-173" data-mp="2zvuk958tnt4h">
          {reflection.cue.question}
        </motion.h2>

        <div className="mt-7" data-id="element-174" data-mp="3is3vlksca5ks">
          <ChoiceCue cue={reflection.cue} selected={selected} onSelect={onSelect} showPeerData={showPeerData} data-id="element-175" data-mp="3irca52sgho88" />
        </div>
      </div>
    </div>;
}